/**
 * Akcioni plan — статуси усклађени са BE енумом за POST /action-plan/status/change.
 * Вредности: DRAFT | IMPLEMENTATION | REVISION | COMPLETED
 */

export const ACTION_PLAN_STATUS_VALUES = Object.freeze([
  'DRAFT',
  'IMPLEMENTATION',
  'REVISION',
  'COMPLETED',
]);

export const ACTION_PLAN_STATUS_LABELS = Object.freeze({
  DRAFT: 'У планирању',
  IMPLEMENTATION: 'У спровођењу',
  REVISION: 'Ревизија',
  COMPLETED: 'Завршен',
});

/** Само за приказ старих уноса из историје / кеша. */
const LEGACY_ACTION_PLAN_STATUS_LABELS = {
  CREATED: 'Креиран',
  PUBLISHED: 'Објављен',
  PENDING: 'На чекању',
  REJECTED: 'Није прихваћен',
};

export const ACTION_PLAN_STATUS_CLASSES = Object.freeze({
  DRAFT: 'status-draft',
  IMPLEMENTATION: 'status-implementation',
  REVISION: 'status-revision',
  COMPLETED: 'status-completed',
});

const LEGACY_ACTION_PLAN_STATUS_CLASSES = {
  CREATED: 'status-created',
  PUBLISHED: 'status-published',
  PENDING: 'status-pending',
  REJECTED: 'status-rejected',
};

export function getActionPlanStatusLabel(status) {
  if (status == null || status === '') return 'Непознат статус';
  const key = String(status).toUpperCase();
  return (
    ACTION_PLAN_STATUS_LABELS[key] ||
    LEGACY_ACTION_PLAN_STATUS_LABELS[key] ||
    String(status)
  );
}

export function getActionPlanStatusClass(status) {
  if (status == null || status === '') return 'status-unknown';
  const key = String(status).toUpperCase();
  return (
    ACTION_PLAN_STATUS_CLASSES[key] ||
    LEGACY_ACTION_PLAN_STATUS_CLASSES[key] ||
    'status-unknown'
  );
}

const STYLE_BY_STATUS = Object.freeze({
  DRAFT: {
    color: '#d97706',
    bgColor: '#fef3c7',
    borderColor: '#f59e0b',
    inactiveBgColor: '#fffbeb',
  },
  IMPLEMENTATION: {
    color: '#1e40af',
    bgColor: '#dbeafe',
    borderColor: '#3b82f6',
    inactiveBgColor: '#eff6ff',
  },
  REVISION: {
    color: '#6d28d9',
    bgColor: '#f5f3ff',
    borderColor: '#a78bfa',
    inactiveBgColor: '#faf5ff',
  },
  COMPLETED: {
    color: '#047857',
    bgColor: '#d1fae5',
    borderColor: '#10b981',
    inactiveBgColor: '#ecfdf5',
  },
});

/** Опције за филтере (аг грид, профил). */
export const ACTION_PLAN_STATUS_FILTER_OPTIONS = Object.freeze(
  ACTION_PLAN_STATUS_VALUES.map((value) => ({
    value,
    label: ACTION_PLAN_STATUS_LABELS[value],
    ...STYLE_BY_STATUS[value],
  }))
);

/** Исти скуп као ACTION_PLAN_STATUS_VALUES (име за профил / филтере). */
export const ACTION_PLAN_STATUS_FILTER_VALUES = ACTION_PLAN_STATUS_VALUES;

export const actionPlanStatusOptions = ACTION_PLAN_STATUS_FILTER_OPTIONS;
